import ProjectData from '@/data/ProjectData.ts'

export default [
    new ProjectData("lgts", "Little Goody Two Shoes | PC, PS5, XBOX & Switch", "img/projects/lgts/lgtscover.png", 
    `
    <div class="paragraph">
    Set in the mysterious Kieferberg Village, <strong>Little Goody Two Shoes™</strong> is a homage to the original PlayStation® and early PlayStation®2 (PS2) RPGs and is centered around Elise, an ambitious girl determined to become rich and escape her humble life. Players will step into Elise’s shoes and soon find themselves immersed in a 90's inspired horror role-playing adventure game. 
    Gameplay elements such as ‘Sustenance’, ‘Reputation & Suspicion’ and ‘Exploration & Narrative’ will guide players to complete their daily tasks by day and uncover the woodland’s darkest secrets by night. 
    Players will also have the ability to set their own paths to navigate through the wicked woods, solve puzzles and build meaningful relationships in this nostalgic gaming experience. 
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/lt6OkYAZcV0" frameborder="0" allowfullscreen></iframe>
    </div>

    <div class="paragraph">
        <strong>What I worked on:</strong>
        <ul>
        <li>Developed and enhanced game functionalities, such as implementing and innovating new mechanics, assisting in designing the game flow, and fine-tuning existing mechanics;</li>
        <li>Sound design with FMOD integration: Implemented sound effects and background music in collaboration with a sound designer;</li>
        <li>Bug identification and fixing: Collaborated with the QA team using Jira to address reported issues and resolved them;</li>
        <li>Collaborated with the team to modify and adjust animation events in both cutscenes and maps, enhancing the visual storytelling of the game using the Unity Timeline.</li>
        </ul>
    </div>

    <div class="notice">
        <strong>Project Info</strong>
        <ul>
        <li>Technologies - Unity | FMOD</li>
        <li>Languages - C# | JSON</li>
        <li>QA & Communication - Jira | Slack</li>
        <li>Project Management - Git</li>
        </ul>
        More info about the game here: </br>
        <a href="https://store.steampowered.com/app/1812370/Little_Goody_Two_Shoes/" target="_blank">Store page</a> | <a href="https://little-goody-two-shoes.square-enix-games.com/en-us/" target="_blank">Website link</a> | <a href="https://twitter.com/AstralShiftPro" target="_blank">Twitter/X</a></br>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/lgts/1.png" alt="LGTS Screenshot" />
        <img class="pc-screenshot" src="img/projects/lgts/2.png" alt="LGTS Screenshot" />
        <img class="pc-screenshot" src="img/projects/lgts/3.png" alt="LGTS Screenshot" />
        <img class="pc-screenshot" src="img/projects/lgts/4.png" alt="LGTS Screenshot" />
    </div>
    `, "#a1170d", true, true),
    new ProjectData("theloop", "The Loop | PC", "img/projects/theloop/4.png", 
    `
    <div class="paragraph">
    <strong>The Loop</strong> is a short horror experience about being stuck on the same floor and on the same hallway.
    <br/> Something is not right, maybe you haven't slept well last night or maybe you're seeing things.
    Is it the elevator? Why am I stuck in this stupid floor?
    <br/> The game features simple puzzles with regular interactions throughout the gameplay. The player must keep going forward in order to "finish" the loop.
    
    </div>

    <div class="paragraph">
        <strong>What I worked on:</strong>
        <ul>
        <li>Programmed the loop states and the transition between them;</li>
        <li>Programmed the flashlight;</li>
        <li>Worked on the player interaction w/ objects and interactables;</li>
        <li>Implemented the UI and its functionality;</li>
        <li>Other extra stuff: camera zoom controller, inspector for items.</li>
        </ul>
    </div>

    <div class="notice">
        <strong>Project Info</strong>
        <ul>
        <li>Technologies - Unity </li>
        <li>Languages - C# </li>
        <li>Project Management - Git & Trello</li>
        </ul>
        Source code is available on <a href="https://github.com/joaocavacos/MAD_LimitedSpace" target="_blank">GitHub</a>.
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/theloop/1.png" alt="The Loop Screenshot" />
        <img class="pc-screenshot" src="img/projects/theloop/2.png" alt="The Loop Screenshot" />
        <img class="pc-screenshot" src="img/projects/theloop/3.png" alt="The Loop Screenshot" />
        <img class="pc-screenshot" src="img/projects/theloop/4.png" alt="The Loop Screenshot" />
        <img class="pc-screenshot" src="img/projects/theloop/5.png" alt="The Loop Screenshot" />
        <img class="pc-screenshot" src="img/projects/theloop/6.png" alt="The Loop Screenshot" />
    </div>
    `, "#35230b", false, true),
    new ProjectData("dontd13", "Don't D13 | PC & Quixant Machine (Linux)", "img/projects/dontd13/1.PNG", 
    `
    <div class="paragraph">
    <strong>Don't D13</strong> is a 3D 1v1 Party Game, which focus on 4 minigames that were done to work in a physical casino machine!
     <br/>Each minigame has a 13 second limit timer in where the players should compete against each other in fun and cute minigames such as: <strong>Button Masher, Count It, Balance and Math Equations!</strong>
     <br/><strong>This was made during a 48-hour game jam (Invictvs Game Jam 2023) with the theme "Number 13", with an additional rule of making it work in a physical casino machine!</strong>
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/FJwp2dVlwsk?si=OGjSJJcrwMIEDZah" frameborder="0" allowfullscreen></iframe>
    </div>

    <div class="paragraph">
        <strong>What I worked on:</strong>
        <ul>
        <li>Programmed 3 minigames: Button Masher, Count It and Math Equations;</li>
        <li>Programmed the logic behind the transitions between minigames and the results displaying after each one;</li>
        <li>Programmed the countdown timer in 3 minigames;</li>
        <li>Implemented sound effects and music;</li>
        <li>Worked with the artists to implement the animations.</li>
        </ul>
    </div>

    <div class="notice">
        <strong>Project Info</strong>
        <ul>
        <li>Technologies - Unity | Quixant </li>
        <li>Languages - C# | JSON </li>
        <li>Project Management - Git & Trello</li>
        </ul>
        Source code is available on <a href="https://github.com/joaocavacos/InvictusGamejam2023" target="_blank">GitHub</a>.
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/dontd13/2.PNG" alt="DontD13 Screenshot" />
        <img class="pc-screenshot" src="img/projects/dontd13/3.PNG" alt="DontD13 Screenshot" />
        <img class="pc-screenshot" src="img/projects/dontd13/4.PNG" alt="DontD13 Screenshot" />
        <img class="pc-screenshot" src="img/projects/dontd13/5.PNG" alt="DontD13 Screenshot" />
        <img class="pc-screenshot" src="img/projects/dontd13/6.PNG" alt="DontD13 Screenshot" />
    </div>
    `, "#5b7be9", false, true),
    new ProjectData("project-2", "Dark Memories | PC", "img/projects/darkmemories-gif.gif", `
    <div class="paragraph">
        <strong>Dark Memories</strong> is a 3D Survival Horror game, with a PSX-style graphic style.
        <br/>It depicts a story of a man who decides to explore a familiar place that awakens the mysteries inside of him and the horrors that there belong...
        <br/><strong>The game was all programmed by myself and I used free art that is credited!</strong>
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/pUFF78woQ7w?si=UFJc4KEdyitTWQ4n" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph">
        <strong>Main features & what I worked on:</strong>
        <ul>
        <li>Puzzles to solve and access unexplored areas</li>
        <li>A ghostly AI figure that chases the player</li>
        <li>Stamina system to limit movement</li>
        <li>Sanity system that is similiar to Amnesia</li>
        <li>PSX-style graphics in modern gameplay</li>
        </ul>
    </div>

    <div class="paragraph">
        <div class="notice">
            <strong>Project Info</strong>
            <ul>
            <li>Technologies - Unity</li>
            <li>Languages - C#</li>
            <li>Project Management - Git | Trello</li>
            </ul>
            Build available on <a href="https://cavacos.itch.io/dark-memories" target="_blank">itch.io</a>.
            Source code is available on <a href="https://github.com/joaocavacos/Horror-Project" target="_blank">GitHub</a>.
        </div>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/darkmemories/1.png" alt="Dark Memories Screenshot" />
        <img class="pc-screenshot" src="img/projects/darkmemories/2.png" alt="Dark Memories Screenshot" />
        <img class="pc-screenshot" src="img/projects/darkmemories/3.png" alt="Dark Memories Screenshot" />
        <img class="pc-screenshot" src="img/projects/darkmemories/4.png" alt="Dark Memories Screenshot" />
        <img class="pc-screenshot" src="img/projects/darkmemories/5.png" alt="Dark Memories Screenshot" />
        <img class="pc-screenshot" src="img/projects/darkmemories/6.png" alt="Dark Memories Screenshot" />
    </div>
    `, "#808080", false, true),
    new ProjectData("project-1", "Prayback | PC", "img/projects/prayback-gif.gif", 
    `
    <div class="paragraph">
     <strong>Prayback</strong> is a 2D Topdown Beat-em-up, which focus on a mongue that needs to defend his temple!
     <br/>The twist is that the player can only attack by parrying - gain energy from blocking enemy attacks and hit them back with twice the power! The objective is to survive the longest! 
     <br/><strong>This was made during a 48-hour game jam with the theme "Comeback", which crowned our team 2nd place!</strong>
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/OSPAgl6aE04" frameborder="0" allowfullscreen></iframe>
    </div>
    
    <div class="paragraph">
        <strong>Main features & what I worked on:</strong>
        <ul>
        <li>Parry and gather energy</li>
        <li>Different attack type based on energy gathered</li>
        <li>Enemy wave system</li>
        <li>Several enemies with different abilities</li>
        </ul>
    </div>

    <div class="notice">
        <strong>Project Info</strong>
        <ul>
        <li>Technologies - Unity</li>
        <li>Languages - C#</li>
        <li>Project Management - Git | Trello</li>
        </ul>
        Build available on <a href="https://cavacos.itch.io/prayback" target="_blank">itch.io</a>.
        Source code is available on <a href="https://github.com/joaocavacos/InvictvsGameJam" target="_blank">GitHub</a>.
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/prayback-screenshots/1.png" alt="Prayback Screenshot" />
        <img class="pc-screenshot" src="img/projects/prayback-screenshots/2.png" alt="Prayback Screenshot" />
        <img class="pc-screenshot" src="img/projects/prayback-screenshots/3.png" alt="Prayback Screenshot" />
        <img class="pc-screenshot" src="img/projects/prayback-screenshots/4.png" alt="Prayback Screenshot" />
    </div>
    `, "#5a78af", false, true),
    new ProjectData("project-3", "The Apprentice | PC", "img/projects/theapprentice.png", `
    <div class="paragraph">
        <strong>The Apprentice</strong> is a 2D Topdown Adventure game, where the player takes character as a knight apprentice!
        <br/>You must go on a mission that will make you an official knight, but you must defeat several enemies and the final boss that lies deep in the cave!
        <br/><strong>The game was all programmed by myself and I used free art that is credited!</strong>
    </div>

    <div class="paragraph">
        <strong>Main features & what I worked on:</strong>
        <ul>
        <li>Player combat and ability system</li>
        <li>NPC interaction</li>
        <li>Controller integration</li>
        <li>An AI boss fight at the end of the level</li>
        </ul>
    </div>

    <div class="paragraph">
        <div class="notice">
            <strong>Project Info</strong>
            <ul>
            <li>Technologies - Unity</li>
            <li>Languages - C#</li>
            <li>Project Management - Git | Trello</li>
            </ul>
            Build available on <a href="https://cavacos.itch.io/the-apprentice" target="_blank">itch.io</a>.
            Source code is available on <a href="https://github.com/joaocavacos/The-Apprentice" target="_blank">GitHub</a>.
        </div>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/theapprentice/1.png" alt="The Apprentice Screenshot" />
        <img class="pc-screenshot" src="img/projects/theapprentice/2.png" alt="The Apprentice Screenshot" />
        <img class="pc-screenshot" src="img/projects/theapprentice/3.png" alt="The Apprentice Screenshot" />
        <img class="pc-screenshot" src="img/projects/theapprentice/4.png" alt="The Apprentice Screenshot" />
        <img class="pc-screenshot" src="img/projects/theapprentice/5.png" alt="The Apprentice Screenshot" />
        <img class="pc-screenshot" src="img/projects/theapprentice/6.png" alt="The Apprentice Screenshot" />
    </div>
    `, "#023020", false, true),
    new ProjectData("project-4", "Knight Typer | PC", "img/projects/knighttyper.png", `
    <div class="paragraph">
    <strong>Knight Typer</strong> is a 2D Sidescroller Typer, that focus on the use of UI elements to control the flow of the game!
    <br/>The player plays as a knight that must type out the word above the enemy quickly before losing all of his health!
    <br/><strong>The game was all programmed by myself and I used free art that is credited!</strong>
    </div>
    
    <div class="paragraph">
        <strong>Main features & what I worked on:</strong>
        <ul>
        <li>Use of only UI elements to control the game</li>
        <li>Enemy spawner system</li>
        <li>High score leaderboard with time and words per minute in the round</li>
        </ul>
    </div>

    <div class="paragraph">
        <div class="notice">
            <strong>Project Info</strong>
            <ul>
            <li>Technologies - Unity</li>
            <li>Languages - C#</li>
            <li>Project Management - Git | Trello</li>
            </ul>
            Build available on <a href="https://cavacos.itch.io/knight-typer" target="_blank">itch.io</a>.
            Source code is available on <a href="https://github.com/joaocavacos/Knight-Typer" target="_blank">GitHub</a>.
        </div>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/knighttyper/1.png" alt="Knight Typer Screenshot" />
        <img class="pc-screenshot" src="img/projects/knighttyper/2.png" alt="Knight Typer Screenshot" />
        <img class="pc-screenshot" src="img/projects/knighttyper/3.png" alt="Knight Typer Screenshot" />
        <img class="pc-screenshot" src="img/projects/knighttyper/4.png" alt="Knight Typer Screenshot" />
        <img class="pc-screenshot" src="img/projects/knighttyper/5.png" alt="Knight Typer Screenshot" />
    </div>
    `, "#00008B", false, true),
];